export default "03ea55d42903c041.ttf"